import { render, staticRenderFns } from "./ResidentBlogs.vue?vue&type=template&id=83f75dae&"
import script from "./ResidentBlogs.vue?vue&type=script&lang=js&"
export * from "./ResidentBlogs.vue?vue&type=script&lang=js&"
import style0 from "./ResidentBlogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports